import React from 'react';

import Dialog from './Dialog';

type ErrorDialogProps = {
  isVisible: boolean;
  onOk: () => void;
  message?: string;
};
export const ErrorDialog = ({isVisible, onOk, message}: ErrorDialogProps) => (
  <Dialog
    cancelVisible={false}
    isVisible={isVisible}
    okText="CLOSE"
    onOk={onOk}
    title={message || 'Sorry, we had an issue with your request. Please try again.'}
  />
);
